"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformComponentStore = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc ITransformComponentStore}
 */
class TransformComponentStore {
    constructor() {
        this.transformsById = new Map();
        this.transforms = new rc_js_util_1.DirtyCheckedUniqueCollection();
    }
    getTransform(userTransformId, graphicsComponent) {
        const associatedTransforms = this.transformsById.get(userTransformId);
        if (associatedTransforms == null) {
            return undefined;
        }
        return associatedTransforms.get(graphicsComponent);
    }
    setTransform(userTransformId, graphicsComponent, transform) {
        const p1 = rc_js_util_1._Map.initializeGet(this.transformsById, userTransformId, () => new Map());
        if (!p1.has(transform)) {
            p1.set(graphicsComponent, transform);
        }
        this.transforms.add(transform);
    }
    getAllTransforms() {
        return this.transforms.getArray();
    }
}
exports.TransformComponentStore = TransformComponentStore;
//# sourceMappingURL=transform-component-store.js.map